import {
  Box,
  Button,
  Card,
  Container,
  Grid,
  Stack,
  Table,
  TableBody,
  TableContainer,
} from "@mui/material";
import { Helmet } from "react-helmet-async";
import { API_URLS, ResDataType } from "src/api/apiUrls";
import useApiServices from "src/api/useApiServices";
import CustomBreadcrumbs from "src/components/custom-breadcrumbs/custom-breadcrumbs";
import Scrollbar from "src/components/scrollbar";
import { useSettingsContext } from "src/components/settings";
import { TableHeadCustom, TableSkeleton } from "src/components/table";
import { paths } from "src/routes/paths";
import QRCodeDialog from "src/sections/apps-integrations/QRCodeDialog";
import AppsIntegrationsTableRow from "../../../sections/apps-integrations/AppsIntegrationsTableRow";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const TABLE_HEAD = [
  { id: "1", label: "Name" },
  { id: "2", label: "Status" },
  { id: "3", label: "QR Code" },
  { id: "4", label: "Actions" },
];

export default function AppsIntegrationsPage() {
  const settings = useSettingsContext();
  const { useGetItemApi, usePostApi } = useApiServices();

  const {
    data: appsIntegrations,
    isLoading,
    refetch,
  } = useGetItemApi<any>({
    url: `${API_URLS.GetStatusSession}`,
  });

  const { mutate: createSessionMutate } = usePostApi({
    url: `${API_URLS.CreateSession}`,
    onSuccess: () => {
      refetch();
    },
  });

  return (
    <>
      <Helmet>
        <title>Apps Integrations</title>
      </Helmet>
      <Stack spacing={4}>
        <CustomBreadcrumbs
          links={[
            {
              name: "Home",
              href: paths.dashboard.root,
            },
            {
              name: "Apps Integrations",
            },
          ]}
        />
        <Container
          maxWidth={settings.themeStretch ? false : "xl"}
          sx={{ height: "100%" }}
        >
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Card>
                <Box display="flex" justifyContent="flex-end" p={3}>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<WhatsAppIcon />}
                    onClick={() =>
                      createSessionMutate({
                        name: "default",
                      })
                    }
                  >
                    Create WhatsApp Session
                  </Button>
                </Box>
                <TableContainer>
                  <Scrollbar>
                    <Table>
                      <TableHeadCustom headLabel={TABLE_HEAD} />
                      <TableBody>
                        {isLoading ? (
                          [...Array(1)].map((i, index) => (
                            <TableSkeleton key={index} sx={{ height: 80 }} />
                          ))
                        ) : (
                          <>
                            <AppsIntegrationsTableRow
                              key={1}
                              row={appsIntegrations}
                              refetch={refetch}
                            />
                          </>
                        )}
                      </TableBody>
                    </Table>
                  </Scrollbar>
                </TableContainer>
                <QRCodeDialog />
              </Card>
            </Grid>
          </Grid>
        </Container>
      </Stack>
    </>
  );
}
